var $894a93a1b5682114$exports = {};
$894a93a1b5682114$exports = {
    "(optional)": `(facoltativo)`,
    "(required)": `(obbligatorio)`
};


export {$894a93a1b5682114$exports as default};
//# sourceMappingURL=it-IT.mjs.map
